import { createStyles, makeUiStyles } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles(() =>
  createStyles({
    title: {
      marginBottom: 24,
    },
    consentItem: {
      marginBottom: 16,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  }), { name: 'ConsentGroup', index: StylesIndexInjections.UI_MOLECULES });
